module.exports = "<footer>\n    <div class=\"text-center\">vQpass Copyright Tisalabs &copy;{{year}} </div>\n</footer>"